//
//
//
//
//
//

export default {
  name: 'App'
};